module.exports = __webpack_public_path__ + "img/ico_expand.svg";